module.exports = __webpack_public_path__ + "static/media/3.d3772d85.jpg";